export default "__VITE_ASSET__DchkuuYm__"